import {API_URL} from '../../../../temp_iot/src/actions/types';
import { Table, Input, Button, Space, Image, Tag} from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import React, { Fragment, useEffect, useState  } from 'react';

import XLSX from 'xlsx';


class SensorTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    searchTerm: '',
    getCurrentSourceData: {},
  };


  // getColumnSearchProps = dataIndex => ({
  //   filterDropdown: ({
  //     setSelectedKeys,
  //     selectedKeys,
  //     confirm,
  //     clearFilters,
  //   }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         ref={node => {
  //           this.searchInput = node;
  //         }}
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={e =>
  //           setSelectedKeys(e.target.value ? [e.target.value] : [])
  //         }
  //         onPressEnter={() =>
  //           this.handleSearch(selectedKeys, confirm, dataIndex)
  //         }
  //         style={{ marginBottom: 8, display: 'block' }}
  //       />
  //       <Space>
  //         <Button
  //           type='primary'
  //           onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
  //           icon={<SearchOutlined />}
  //           size='small'
  //           style={{ width: 90 }}
  //         >
  //           Search
  //         </Button>
  //         <Button
  //           onClick={() => this.handleReset(clearFilters)}
  //           size='small'
  //           style={{ width: 90 }}
  //         >
  //           Reset
  //         </Button>
  //         <Button
  //           type='link'
  //           size='small'
  //           onClick={() => {
  //             confirm({ closeDropdown: false });
  //             this.setState({
  //               searchText: selectedKeys[0],
  //               searchedColumn: dataIndex,
  //             });
  //           }}
  //         >
  //           Filter
  //         </Button>
  //       </Space>
  //     </div>
  //   ),
  //   filterIcon: filtered => (
  //     <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  //   ),
  //   onFilter: (value, record) =>
  //     record[dataIndex]
  //       ? record[dataIndex]
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase())
  //       : '',
  //   onFilterDropdownVisibleChange: visible => {
  //     if (visible) {
  //       setTimeout(() => this.searchInput.select(), 100);
  //     }
  //   },
  //   render: text =>
  //     this.state.searchedColumn === dataIndex ? (
  //       <Highlighter
  //         highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
  //         searchWords={[this.state.searchText]}
  //         autoEscape
  //         textToHighlight={text ? text.toString() : ''}
  //       />
  //     ) : (
  //       text
  //     ),
  // });

  setSearchTerm = () =>{
    this.setState({
      searchTerm: '',
    })
  }

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  // const [searchText, setSearchText] = useState('');
  // const [page, setPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);

  onChange = (pagination, filters, sorter, extra) => {
    // this.setState({
    //   getCurrentSourceData: extra.currentDataSource,
    // });

    this.setState({
      getCurrentSourceData: extra.currentDataSource,
    });
  };

  downloadCSV = () => {
    
    let worksheet;
    if (this.state.getCurrentSourceData.length > 0) {
      const newData = this.state.getCurrentSourceData.map(row => {
        delete row.__v;
        return row;
      });
      worksheet = XLSX.utils.json_to_sheet(newData);
    } else {
      worksheet = XLSX.utils.json_to_sheet(this.props.sensorData);
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
    XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    //Binary string
    XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    //Download
    XLSX.writeFile(workbook, `sensory_data_${Date.now()}.xlsx`);
  };
  render() {
    const columns = [
      {
        title: 'Action',
        dataIndex: 'action',
        // render: (text, record) => record.img_filepath ? (<Fragment>
        //   <Link
        // to={{
        //   pathname: `/monitor/${this.props.vehicleId}/${record._id}/review`,
        //   state: record,
        // }}><Button type="link">View</Button></Link>
        // </Fragment>): (<Fragment></Fragment>),
        render: (text, record) => {
          return [
            <Link to={{
              pathname: `/monitor/${this.props.vehicleId}/${record._id}/review`,
              state: record,
            }}>
              <Button type='link'>View</Button>
            </Link>
          ]
        }
      },
      {
        title: 'Image',
        dataIndex: 'img_filepath',
        key: 'img_filepath',

        render: img_filepath => img_filepath ? (<Fragment>
          <Image width={"100%"} height={"100%"} src={API_URL+"/"+img_filepath} fallback="data:image/png;base64,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"/>
        </Fragment>):(<Fragment>

        </Fragment>)

      },
      {
        title: 'Sound Sensor',
        dataIndex: 'sound_sensor',
        key: 'sound_sensor',
        sorter:(a, b) => {
          return String(a.sound_sensor).localeCompare(String(b.sound_sensor))
        }
        // ...this.getColumnSearchProps('sound_sensor'),
      },
      {
        title: 'Alcohol Sensor',
        dataIndex: 'alcohol_sensor',
        key: 'alcohol_sensor',
        sorter:(a, b) => {
          return String(a.alcohol_sensor).localeCompare(String(b.alcohol_sensor))
        }
        // ...this.getColumnSearchProps('alcohol_sensor'),
      },
      {
        title: 'Ultrasonic Sensor',
        dataIndex: 'ultrasonic_sensor',
        key: 'ultrasonic_sensor',
        sorter:(a, b) => {
          return String(a.ultrasonic_sensor).localeCompare(String(b.ultrasonic_sensor))
        }
        // ...this.getColumnSearchProps('ultrasonic_sensor'),
      },
      {
        title: 'Accelerometer X Axis',
        dataIndex: 'gyro_sensor_acceleration_x',
        key: 'gyro_sensor_acceleration_x',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_x).localeCompare(String(b.gyro_sensor_acceleration_x))
        }
        // ...this.getColumnSearchProps('gyro_sensor_acceleration_x'),
      },
      {
        title: 'Accelerometer Y Axis',
        dataIndex: 'gyro_sensor_acceleration_y',
        key: 'gyro_sensor_acceleration_y',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_y).localeCompare(String(b.gyro_sensor_acceleration_y))
        }
        // ...this.getColumnSearchProps('gyro_sensor_acceleration_y'),
      },
      {
        title: 'Accelerometer Z Axis',
        dataIndex: 'gyro_sensor_acceleration_z',
        key: 'gyro_sensor_acceleration_z',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_z).localeCompare(String(b.gyro_sensor_acceleration_z))
        }
        // ...this.getColumnSearchProps('gyro_sensor_acceleration_z'),
      },
      {
        title: 'Gyro Sensor Rotation X',
        dataIndex: 'gyro_sensor_rotation_x',
        key: 'gyro_sensor_rotation_x',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_x).localeCompare(String(b.gyro_sensor_rotation_x))
        }
        // ...this.getColumnSearchProps('gyro_sensor_rotation_x'),
      },
      {
        title: 'Gyro Sensor Rotation Y',
        dataIndex: 'gyro_sensor_rotation_y',
        key: 'gyro_sensor_rotation_y',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_y).localeCompare(String(b.gyro_sensor_rotation_y))
        }
        // ...this.getColumnSearchProps('gyro_sensor_rotation_y'),
      },
      {
        title: 'Gyro Sensor Rotation Z',
        dataIndex: 'gyro_sensor_rotation_z',
        key: 'gyro_sensor_rotation_z',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_z).localeCompare(String(b.gyro_sensor_rotation_z))
        }
        // ...this.getColumnSearchProps('gyro_sensor_rotation_z'),
      },
      {
        title: 'Gyro Sensor Temperature',
        dataIndex: 'gyro_sensor_temperature',
        key: 'gyro_sensor_temperature',
        sorter:(a, b) => {
          return String(a.gyro_sensor_temperature).localeCompare(String(b.gyro_sensor_temperature))
        }
        // ...this.getColumnSearchProps('gyro_sensor_temperature'),
      },
      {
        title: 'Latitude',
        dataIndex: 'latitude',
        key: 'latitude',
        sorter:(a, b) => {
          return String(a.latitude).localeCompare(String(b.latitude))
        }
        // ...this.getColumnSearchProps('latitude'),
      },
      {
        title: 'Longitude',
        dataIndex: 'longitude',
        key: 'longitude',
        sorter:(a, b) => {
          return String(a.longitude).localeCompare(String(b.longitude))
        }
        // ...this.getColumnSearchProps('longitude'),
      },
  
      {
        title: 'Vehicle Speed',
        dataIndex: 'max_gps_speed',
        key: 'max_gps_speed',
        sorter:(a, b) => {
          return String(a.max_gps_speed).localeCompare(String(b.max_gps_speed))
        }
        // ...this.getColumnSearchProps('max_gps_speed'),
      },
      {
        title: 'Sensor Date',
        dataIndex: 'sensor_date',
        key: 'sensor_date',
        sorter:(a, b) => {
          return String(a.sensor_date).localeCompare(String(b.sensor_date))
        }
        // ...this.getColumnSearchProps("sensor_date")
      },
      {
        title: 'Sign',
        dataIndex: 'status_1',
        key: 'status_1',
        sorter:(a, b) => {
          return String(a.status_1).localeCompare(String(b.status_1))
        }
        // ...this.getColumnSearchProps('status_1'),
      },
      {
        title: 'Remark',
        dataIndex: 'status_2',
        key: 'status_2',
        // sorter:(a, b) => {
        //   return String(a.status_2).localeCompare(String(b.status_2))
        // },
        filters: [
          {
            text: 'Good',
            value: 'good',
          },
          {
            text: 'Bad',
            value: 'bad',
          },
        ],
        onFilter: (value, record) => record.status_2.indexOf(value) === 0,
        render: status_2 => {
          return [
            status_2 === 'good' ? (
              <Tag color='green'>{status_2.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
            status_2 === 'bad' ? (
              <Tag color='red'>{status_2.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
          ];
        },
        // ...this.getColumnSearchProps('status_2'),
      },
      {
        title: 'Validation',
        dataIndex: 'status_4',
        key: 'status_4',
        // sorter:(a, b) => {
        //   return String(a.status_4).localeCompare(String(b.status_4))
        // },
        filters: [
          {
            text: 'Validated',
            value: 'validated',
          },
          {
            text: 'Not-Validated',
            value: 'not-validated',
          },
        ],
        onFilter: (value, record) => record.status_4.indexOf(value) === 0,
        render: status_4 => {
          return [
            status_4 === 'validated' ? (
              <Tag color='green'>{status_4.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
            status_4 === 'not-validated' ? (
              <Tag color='red'>{status_4.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
          ];
        },
        // ...this.getColumnSearchProps('status_4'),
      },
    ];

    return (
      <Fragment>
        
        <Table
          style={{ marginTop: "20px" }}
          columns={columns}
          onChange={this.onChange}
          dataSource={this.props.sensorData}
          key={this.props.sensorData._id}
          scroll={{ x: 3500, y: 1500 }}
          title={() => (
            <div style={{ justifyContent: 'right', display: 'flex' }}>
              <h3 style={{color: '#2db7f5' }}> </h3>{' '}
              <Button type='link' onClick={this.downloadCSV}>
                {' '}
                Download as XLSX{' '}
              </Button>
            </div>
            
          )}
          
          
          
          className="card"
          size='small'
        />
        
      </Fragment>
    );
  }
}

export default SensorTable;
